export const LOGIN_LINK = '/login';
export const ROLES_LINK = '/roles';
export const ROLE_LINK = '/roles/:id';
export const NEW_ROLE_LINK = '/roles/new';
export const USERS_LINK = '/users';
export const USER_LINK = '/users/:id';
export const NEW_USER_LINK = '/users/new';
export const PROFILE_LINK = '/profile';
export const GRID_LIST_LINK = '/grid/:name';
export const GRID_CARD_LINK = '/grid/:name/:id';
export const GRID_NEW_LINK = '/grid/:name/new';
export const GRID_AUTO_GROUPING_LINK = '/grid/:name/autogrouping';
export const REPORT_LINK = '/report/:type';
export const KPI_INDICATORS_SETTINGS_LINK = '/report/:type/:extType';
export const DICTIONARY_LIST_LINK = '/dictionary/:name';
export const DICTIONARY_CARD_LINK = '/dictionary/:name/:id';
export const DICTIONARY_NEW_LINK = '/dictionary/:name/new';
export const FIELDS_SETTING_LINK = '/fields_setting';

export const customPage = [ROLES_LINK, USERS_LINK, FIELDS_SETTING_LINK, GRID_AUTO_GROUPING_LINK, REPORT_LINK, KPI_INDICATORS_SETTINGS_LINK];
